import { t } from '@lingui/core/macro';
import { SystemDriverName } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

export const getSystemDriverNotes = (driverName: SystemDriverName): string => {
    switch (driverName) {
        case 'pcb_width':
        case 'pcb_height':
        case 'pcb_thickness':
        case 'panel_width':
        case 'panel_height':
            return t`in mm`;
        case 'panel_factor':
            return t`PCBs/panel`;
        case 'pcb_layer_count':
            return t`count`;
        case 'pcb_inner_copper_thickness':
        case 'pcb_outer_copper_thickness':
            return t`in µm`;
        case 'pcb_enig_thickness':
            return t`in µin`;
        case 'Sides_of_placement':
            return t`1 or 2`;
        default:
            assertUnreachable(driverName);
    }
};
